import deFlag from '@/assets/de_flag.svg'
import enFlag from '@/assets/en_flag.svg'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { cx } from '@utils/cx.ts'

import type { ImgHTMLAttributes } from 'react'

function Flag({ lang, className, ...props }: {lang: 'de' | 'en'} & ImgHTMLAttributes<HTMLImageElement>) {
  const { t } = useTypedTranslation()

  const flags = {
    de: deFlag,
    en: enFlag,
  }

  const values = {
    de: t('account.language.options.de'),
    en: t('account.language.options.en'),
  }

  return <img src={flags[lang]} className={cx('size-6 max-w-none rounded-full', className)} alt={`${values[lang]} flag`} {...props} />
}

export default Flag